import * as React from 'react'
import { FC } from 'react'
import Box, { BoxProps } from '@mui/material/Box'
const Trophy: FC<BoxProps<'svg'>> = (props) => (
  <Box
    component={'svg'}
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    viewBox="0 0 48 48"
    {...props}
  >
    <g id="Layer_1">
      <path
        d="M29.277 36.018H18.723c-.94 0-1.701.762-1.701 1.701v1.702h13.956v-1.702c0-.94-.761-1.7-1.701-1.7z"
        style={{
          fill: '#ff612b',
        }}
      />
      <path d="M21.043 23.078h5.914V37.4h-5.914z" className="st0" />
      <path
        d="M34.678 43.5H13.322v-1.89c0-1.21.98-2.19 2.19-2.19h16.977c1.209 0 2.19.98 2.19 2.19v1.89z"
        style={{
          fill: '#002677',
        }}
      />
      <path
        d="M15.002 8.96H8.078c-.818 0-1.557.548-1.923 1.39-.697 1.601.258 3.936.814 5.432 1.405 3.778 4.094 8.112 8.033 8.112M32.998 8.96h6.924c.818 0 1.557.548 1.924 1.39.696 1.601-.259 3.936-.815 5.432-1.405 3.778-4.094 8.112-8.033 8.112"
        style={{
          fill: 'none',
          stroke: '#002677',
          strokeWidth: '2.5',
          strokeLinecap: 'round',
          strokeMiterlimit: 10,
        }}
      />
      <path
        d="M35.995 11.723V4.438h-23.99v7.286h.009c-.002.127-.009.252-.009.38 0 10.475 5.37 18.966 11.995 18.966 6.625 0 11.995-8.491 11.995-18.966 0-.128-.007-.253-.009-.38h.009z"
        className="st0"
        style={{
          fill: '#ff612b',
        }}
      />
    </g>
  </Box>
)
export default Trophy
